export default __webpack_public_path__ + "static/media/reservations.adb7a475.svg";